module.exports = __webpack_public_path__ + "assets/img/202107-5.69d8dfe3.png";